'use client';

import { GetWrapupType } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleFinaleComponent from "./finalecomponent";

export default class WrapupModuleFinale implements IWrapupModule {
    constructor() { }

    get id(): string { return 'finale'; }
    get name(): string { return 'Finale'; }

    canRender(data: GetWrapupType): boolean {
        return true;
    }

    getComponentClass() {
        return WrapupModuleFinaleComponent;
    }
}
